<template>
  <div class="controller">
    <!-- 顶部Banner：和其他页面完全一致 -->
    <banner img="../assets/img/bgtop.jpg" title="自研智能终端" />

    <div class="controller-content">

      <!-- 产品视频 -->
      <div class="p-video">
        <h3 class="title">Sharpin iEdge Controller</h3>
        <p class="eTitle">自研智能终端</p>

        <video-player
          :key="playerKey"
          ref="videoPlayer"
          class="video-player vjs-custom-skin"
          :playsinline="true"
          :options="playerOptions"
        ></video-player>
      </div>

      <!-- 对比一：传统网关 -->
      <div class="compare">
        <h3 class="title">与传统智能网关对比</h3>
        <table>
          <thead>
            <tr>
              <th>对比维度</th>
              <th>传统智能网关</th>
              <th>Sharpin iEdge Controller</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="row in gatewayCompare" :key="row.title">
              <td class="left">{{row.title}}</td>
              <td>{{row.old}}</td>
              <td class="highlight">{{row.new}}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- 对比二：WinCC -->
      <div class="compare">
        <h3 class="title">与 WinCC / SCADA 对比</h3>
        <table>
          <thead>
            <tr>
              <th>对比维度</th>
              <th>WinCC / SCADA</th>
              <th>Sharpin iEdge Controller</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="row in winccCompare" :key="row.title">
              <td class="left">{{row.title}}</td>
              <td>{{row.old}}</td>
              <td class="highlight">{{row.new}}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- 对比三：KEPWARE -->
      <div class="compare">
        <h3 class="title">与 KEPWARE 对比</h3>
        <table>
          <thead>
            <tr>
              <th>对比维度</th>
              <th>KEPWARE</th>
              <th>Sharpin iEdge Controller</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="row in kepwareCompare" :key="row.title">
              <td class="left">{{row.title}}</td>
              <td>{{row.old}}</td>
              <td class="highlight">{{row.new}}</td>
            </tr>
          </tbody>
        </table>
      </div>

    </div>
  </div>
</template>
<script>
import Banner from "../components/Banner";

export default {
  components:{ Banner },
  watch: {
    $route: {
      handler(to, from) {
        console.log('route changed full')
        this.rebuildPlayer()
      },
      deep: true,
      immediate: true
    }
  },

  activated() {
    this.rebuildPlayer()
  },
  data() {
    return {
      playerKey: 1,
      playerOptions: {
        playbackRates: [0.5, 1.0, 1.5, 2.0, 4.0, 8.0], //可选择的播放速度
        autoplay: "muted",//如果true,浏览器准备好时开始回放。
        muted: true, // 默认情况下将会消除任何音频。
        loop: true, // 视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9",// 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          { type: "video/mp4", src: "/video/kj2.mp4" }
        ],
        notSupportedMessage: "视频暂无法播放",
        controlBar: {
          timeDivider: true, //当前时间和持续时间的分隔符
          durationDisplay: true, //显示持续时间
          remainingTimeDisplay: false, //是否显示剩余时间功能
          fullscreenToggle: true //全屏按钮
        }
      },

      gatewayCompare:[
        {title:"核心定位", old:"协议翻译、数据透传", new:"数据枢纽 + 边缘计算 + 云边协同"},
        {title:"软件 / 硬件", old:"硬件为主，功能固化", new:"硬件/软件，灵活部署"},
        {title:"协议数量", old:"少（约5~30 种）", new:"80+工业协议"},
        {title:"南向能力", old:"基础采集", new:"深度采集、符号寻址、非标支持"},
        {title:"北向协议", old:"OPC、数据库", new:"MQTT/Sparkplug B/Kafka/HTTP/ 云原生"},
        {title:"边缘计算", old:"无", new:"流计算、规则引擎、AI 本地推理"},
        {title:"并发性能", old:"低（<30 设备，100-1000点）", new:"高（100 + 设备，10 万 + 点）"},
        {title:"资源占用", old:"硬件固定", new:" 极低（<100MB）"},
        {title:"部署方式", old:"专用硬件", new:"通用硬件、容器、虚拟机、ARM/x86"},
        {title:"云边协同", old:"少数高端品牌", new:"原生支持，双向互通"},
        {title:"远程运维", old:"困难", new:"集中管理、批量升级、远程诊断"},
        {title:"展示功能", old:"无", new:"接上显示器，即可展示图表，能源分析，历史数据，报警信息"},
        {title:"适用场景", old:"小型项目、少数协议、本地 SCADA", new:"大规模、多品牌、上云、边缘智能、IIoT"}
      ],

      winccCompare:[
        {title:"核心定位", old:"SCADA/HMI（带通信）", new:"具有多协议的边缘控制器，具有数据分析、展示功能"},
        {title:"协议数量", old:"约 20 种（西门子为主）", new:"80 + 种（全行业覆盖）"},
        {title:"南向能力", old:"S7 最优，第三方有限", new:"S7/Modbus/OPC UA / 三菱 / 罗克韦尔自动化 / 电力 / 楼宇全覆盖"},
        {title:"北向协议", old:"OPC DA/UA、传统 IT", new:"MQTT/Sparkplug B/HTTP/Kafka/ 云原生"},
        {title:"架构", old:"集中式、HMI 绑定", new:"分布式、边缘原生、松耦合"},
        {title:"跨平台", old:"Windows only", new:"Linux/Windows/ARM/ 容器全支持"},
        {title:"资源占用", old:"高（Windows+SQL+HMI）", new:" 极低（<100MB）"},
        {title:"并发能力", old:"中小规模（几千点）", new:"大规模（10 万+点、100+设备）"},
        {title:"协议转换", old:"弱（基本无）", new:"强（任意协议互转）"},
        {title:"上云能力", old:"差（需中间件）", new:"原生（MQTT/Sparkplug）"},
        {title:"软硬件", old:"纯软件", new:"软硬件结合，软件可单独授权"},
        {title:"稳定性", old:"高（但系统庞大）", new:"极高（轻量、Linux、崩溃自愈）"},
        {title:"适用场景", old:"纯西门子、本地 HMI/SCADA", new:"多品牌、边缘、上云、大规模、分布式"}
      ],

      kepwareCompare:[
        {title:"软件架构", old:"重型 Windows 桌面应用", new:"轻量化、模块化、云原生"},
        {title:"协议数量", old:"160+ 驱动", new:"80 + 种"},
        {title:"数据处理", old:"基本转发、简单标签计算", new:"主流工控 + 云协议（Modbus、OPC UA、MQTT、Kafka、HTTP），数量少于 KEPWARE"},
        {title:"云台对接", old:"需要有中间插件", new:"MQTT/Sparkplug B/HTTP/Kafka/ 云原生"},
        {title:"远程运维", old:"困难", new:"集中管理、远程配置、API 丰富，自动化运维友好"},
        {title:"跨平台", old:"Windows only", new:"Linux/Windows/ARM/ 容器全支持"},
        {title:"成本", old:"商业授权，按驱动 / 标签收费，较贵", new:"边缘部署成本低"},
        {title:"可用性", old:"双机热备插件", new:"原生集群、负载均衡、断点续"},
        {title:"部署规模", old:"适合集中式、中等规模（万点级）", new:"适合分布式、大规模边缘节点（千点级 / 节点，可集群）"}
      ]
    };
  },
  methods: {
    rebuildPlayer() {
      this.playerKey ++   // ⭐强制销毁 + 重建 video.js
      this.$nextTick(function () {
        
        setTimeout(() => {
          const videoPlayer = this.$refs.videoPlayer
          if (!videoPlayer) return

          const player = videoPlayer.player
          if (!player) return

          player.pause()
          player.currentTime(0)

          player.play().catch(err => {
            console.log('自动播放失败:', err)
          })
        }, 300)



      })
    }
  }
};
</script>
<style lang="scss" scoped>
.controller {
  width:100%;
  background:#14679f;
}

.controller-content {
  width:1240px;
  margin:0 auto;
  background:#fff;
}

/* 视频 */
.p-video{
  width:1000px;
  margin:0 auto;
  padding:60px 0;
}

/* 对比表 */
.compare{
  padding:60px 80px;
}

table{
  width:100%;
  border-collapse:collapse;
  margin-top:30px;
}


th{
  background:#2e6ea6;
  color:#fff;
  padding:18px 16px;   // 与 td 保持一致
  font-size:18px;
  text-align:left;     // ⭐关键：改成左对齐
  border-right:1px solid #ffffff33;
}
td{
  padding:16px;
  border-bottom:1px solid #e5e5e5;
  font-size:16px;
}


.left{
  font-weight:600;
  color:#2e6ea6;
  background:#f7f9fc;
}

.highlight{
  color:#1677ff;
  font-weight:bold;
}

.title,.eTitle{
  font-size:34px;
  color:#333;
  text-align:center;
}

.eTitle{
  font-size:28px;
  padding:10px 0;
}
</style>